var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"primary-button",class:{
		'primary-button--outlined': _vm.outlined,
		'primary-button--disabled': _vm.disabled,
		'primary-button--large': _vm.large,
		'primary-button--full-width': _vm.fullWidth,
		'primary-button--loading': _vm.loading,
		'primary-button--rounded': _vm.rounded,
		'primary-button--dark-theme': _vm.darkTheme,
		lighter: _vm.lighter
	},attrs:{"disabled":_vm.disabled,"ontouchstart":""},on:{"click":_vm.onClick}},[_c('span',{staticClass:"content"},[_vm._t("default")],2),(_vm.loading)?_c('button-loader',{attrs:{"large":_vm.large}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }